import React from 'react';
import {
  ShieldCheck, Heart, Sparkles, Activity, FlaskConical, Brain,
} from 'lucide-react';
import { PillarHub } from './PillarHub';

export default function LongevityHubPage() {
  return (
    <PillarHub
      testid="longevity-hub"
      pillar="Longevity"
      category="Longevity"
      eyebrow="The Longevity Pillar"
      headline="Add years to your life. Add life to your years."
      subhead="NAD+, NMN, senolytics, GHK-Cu, MOTS-c — the protocols, the science, and the calculators to measure your own healthspan."
      primaryCta={{
        label: 'Calculate your longevity score',
        href: '/tools/longevity-score',
      }}
      trustSignals={[
        { icon: ShieldCheck, label: 'Evidence-based', detail: 'NIH / PubMed / Nature sources' },
        { icon: Sparkles, label: 'Peer-reviewed', detail: '60+ longevity citations' },
        { icon: FlaskConical, label: 'Peptide focus', detail: 'MOTS-c · Epitalon · GHK-Cu' },
        { icon: Activity, label: 'Biomarker-driven', detail: 'NAD+ · Telomere · VO2max' },
      ]}
      tools={[
        { label: 'Longevity Score', href: '/tools/longevity-score', icon: Heart },
        { label: 'Biohacking Score', href: '/tools/biohacking-score', icon: Brain },
        { label: 'TDEE Calculator', href: '/tools/tdee-calculator', icon: Activity },
        { label: 'Peptide Cycle', href: '/tools/peptide-cycle-tracker', icon: FlaskConical },
      ]}
      fallbackTagMatches={['longevity', 'nad', 'nmn', 'mots-c', 'epitalon', 'ghk-cu', 'senolytics']}
      locatorFeeder={{
        heading: 'Find longevity clinics near you',
        blurb: 'NAD+ infusions, peptide protocols and hormone optimization — find vetted clinics in 25 metros with our free locator.',
        therapies: [
          { slug: 'nad-iv', name: 'NAD+ Therapy' },
          { slug: 'peptide-therapy', name: 'Peptide Therapy' },
          { slug: 'hormone-therapy', name: 'Hormone / TRT' },
        ],
      }}
      bgVideo={null}
    />
  );
}
